import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { dateFormatFunction } from '@/custom/common/components'
import ProductCommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ProductContext from '@/product/context/seller/product/productContext'
import CustomCommonContext from '@/custom/context/common/commonContext'

const UserView = (props) => {
    const productContext = useContext(ProductContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { allCategory, allCondition, allLocations, alldata_all_dropdown } = customCommonContext
    const {
        getProjectAccessRequest,
        all_project_access_req,
        projectAccessReqStatus,
        responseStatus: productResponseStatus,
        clearResponse: clearResponseProduct,
    } = productContext

    const productCommonContext = useContext(ProductCommonContext)
    const { allCountries, allStates } = productCommonContext
    const [reload, setReload] = useState(false)

    const [userData, setUserData] = useState(null)
    const [viewData, setViewData] = useState(null)
    // const [allUserData, setAllUserData] = useState({})

    const data = props.data
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            users_first_name: '',
            users_last_name: '',
            users_email: '',
            users_phone: '+1',
            users_zip: '',
            users_country: '',
            users_state: '',
            users_city: '',
            users_address1: '',
            users_address2: '',
            custom_users_job_title: '',
            custom_users_seniority: '',
            custom_users_job_function: '',
            custom_users_company_category: '',
            custom_users_asset_class_focus: '',
            custom_users_company_start_date: '',
            custom_users_position_start_date: '',
            custom_users_company_head_count: '',
            custom_users_bio_data: '',
            users_companyname: '',
            custom_users_repossibility_desc: '',
            id: 0,
        },
        validateOnBlur: false,
        onSubmit: (values) => {},
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getProjectAccessRequest(
                {
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    action: 0,
                    searchterm: '',
                    // group_id: 0,
                    filters: {
                        auctionid: {
                            value: 0,
                            type: 'in',
                            field: 'par.project_id',
                        },
                        userid: {
                            value: data.id,
                            type: 'in',
                            field: 'u.id',
                        },
                        approved: {
                            value: '',
                            type: 'in',
                            field: 'par.approved_type',
                        },
                    },
                    tableJoins: [
                        {
                            baseTable: 'users',
                            customTable: 'custom_users',
                            joinType: 'left',
                            baseJoinField: 'id',
                            connectJoinField: 'requested_user_id',
                        },
                    ],
                },
                'viewUser',
            )
        } else {
            resetFrom()
        }
    }, [data.id])

    useEffect(() => {
        if (
            all_project_access_req &&
            all_project_access_req.from === 'viewUser' &&
            all_project_access_req.records.length
        ) {
            const template = all_project_access_req.records[0]
            setUserData(template)
            formik.values.id = template?.id || 0
            formik.values.users_first_name = template?.users_first_name || ''
            formik.values.users_last_name = template?.users_last_name || ''
            formik.values.users_email = template?.users_email || ''
            formik.values.users_phone = template?.users_phone || ''
            formik.values.users_zip = template?.users_zip || ''
            formik.values.users_country = template?.users_country || ''
            formik.values.users_state = template?.users_state || ''
            formik.values.users_city = template?.users_city || ''
            formik.values.users_address1 = template?.users_address1 || ''
            formik.values.users_address2 = template?.users_address2 || ''
            formik.values.custom_users_job_title = template?.custom_users_job_title || ''
            formik.values.custom_users_seniority = template?.custom_users_seniority || ''
            formik.values.custom_users_job_function = template?.custom_users_job_function || ''
            formik.values.custom_users_company_category =
                template?.custom_users_company_category || ''
            formik.values.custom_users_asset_class_focus =
                template?.custom_users_asset_class_focus || ''
            formik.values.custom_users_company_start_date =
                dateFormatFunction(template?.custom_users_company_start_date) || ''
            formik.values.custom_users_position_start_date =
                dateFormatFunction(template?.custom_users_position_start_date) || ''
            formik.values.custom_users_company_head_count =
                template?.custom_users_company_head_count || ''
            formik.values.custom_users_bio_data = template?.custom_users_bio_data || ''
            formik.values.custom_users_repossibility_desc =
                template?.custom_users_repossibility_desc || ''
            formik.values.users_companyname = template?.users_companyname || ''
            setReload(!reload)
        } else {
            resetFrom()
        }
    }, [all_project_access_req, alldata_all_dropdown])

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.users_first_name = ''
        formik.values.users_last_name = ''
        formik.values.users_email = ''
        formik.values.users_phone = ''
        formik.values.users_zip = ''
        formik.values.users_country = ''
        formik.values.users_state = ''
        formik.values.users_city = ''
        formik.values.users_address1 = ''
        formik.values.users_address2 = ''
        formik.values.users_companyname = ''
        formik.handleReset()
    }

    // const emailTemplate = []

    // emailTemplate.push(
    //     {
    //         label: 'First Name',
    //         placeholder: 'Enter First Name',
    //         class: 'col-sm-6 col-12',
    //         type: '',
    //         shrink: true,
    //         name: 'users_first_name',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Last Name',
    //         placeholder: 'Enter Last Name',
    //         class: 'col-sm-6 col-12',
    //         type: 'text',
    //         shrink: true,
    //         name: 'users_last_name',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Email Address',
    //         placeholder: 'Enter Email Address',
    //         class: 'col-sm-6 col-12',
    //         type: 'text',
    //         shrink: true,
    //         name: 'users_email',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Phone',
    //         placeholder: 'Enter Phone number',
    //         class: 'col-sm-6 col-12',
    //         type: 'phone',
    //         shrink: true,
    //         name: 'users_phone',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Postal Code',
    //         placeholder: 'Enter Postal Code',
    //         class: 'col-sm-6 col-12',
    //         type: 'number',
    //         shrink: true,
    //         name: 'users_zip',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Country *',
    //         placeholder: 'Enter your country',
    //         class: 'col-sm-6 col-12',
    //         type: 'select',
    //         options: allCountries
    //             .filter((country) => global.ignoreCountry.indexOf(country.isoCode) === -1)
    //             .map((country) => {
    //                 let busCategoryChanged = {}
    //                 busCategoryChanged.show = country.name
    //                 busCategoryChanged.value = country.isoCode
    //                 return busCategoryChanged
    //             }),
    //         name: 'users_country',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'State *',
    //         placeholder: 'Enter your state',
    //         class: `col-sm-6 col-12`,
    //         type: 'select',
    //         options: allStates
    //             .filter(
    //                 (state) =>
    //                     (formik.values.users_country
    //                         ? formik.values.users_country.indexOf(state.countryCode) !== -1
    //                         : global.defaultCountry.indexOf(state.countryCode) !== -1) &&
    //                     global.ignoreStates.indexOf(state.isoCode) === -1,
    //             )
    //             .map((buscat) => {
    //                 let busCategoryChanged = {}
    //                 busCategoryChanged.show = buscat.name
    //                 busCategoryChanged.value = buscat.isoCode
    //                 return busCategoryChanged
    //             }),
    //         name: 'users_state',
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'City',
    //         name: 'users_city',
    //         type: 'text',
    //         placeholder: 'Enter your city',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Address 1',
    //         name: 'users_address1',
    //         type: 'text',
    //         placeholder: 'enter_your_address',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Address 2',
    //         name: 'users_address2',
    //         type: 'text',
    //         placeholder: 'enter_your_address',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Job Title',
    //         name: 'custom_users_job_title',
    //         type: 'text',
    //         placeholder: 'enter_your_address',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Company Name',
    //         name: 'users_companyname',
    //         type: 'text',
    //         placeholder: 'enter_your_comapny',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Seniority',
    //         name: 'custom_users_seniority',
    //         type: 'select',
    //         options: alldata_all_dropdown
    //             .filter((data) => data.variable === 'seniority')
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //         placeholder: 'Select seniority',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Job Function',
    //         name: 'custom_users_job_function',
    //         type: 'select',
    //         options: alldata_all_dropdown
    //             .filter((data) => data.variable === 'job_function')
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //         placeholder: 'Select job function',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Current company Category',
    //         name: 'custom_users_company_category',
    //         type: 'select',
    //         options: alldata_all_dropdown
    //             .filter((data) => data.variable === 'company_category')
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //         placeholder: 'Select Category',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Asset Class Focus',
    //         name: 'custom_users_asset_class_focus',
    //         type: 'select',
    //         options: alldata_all_dropdown
    //             .filter((data) => data.variable === 'asset_class_focus')
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //         placeholder: 'Select Focus',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Company Start Date',
    //         name: 'custom_users_company_start_date',
    //         type: 'date',
    //         placeholder: 'Enter Date',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Current Position Start Date',
    //         name: 'custom_users_position_start_date',
    //         type: 'date',
    //         placeholder: 'Enter Date',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Current Company Headcount',
    //         name: 'custom_users_company_head_count',
    //         type: 'select',
    //         options: alldata_all_dropdown
    //             .filter((data) => data.variable === 'company_head_count')
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //         placeholder: 'Select head count',
    //         class: `col-sm-6 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Professional Profile',
    //         name: 'custom_users_bio_data',
    //         type: 'ckeditor5',
    //         placeholder: 'Select head count',
    //         class: `col-sm-12 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    //     {
    //         label: 'Current Responsibilties,Interests and Expertise',
    //         name: 'custom_users_repossibility_desc',
    //         type: 'ckeditor5',
    //         placeholder: 'Select head count',
    //         class: `col-sm-12 col-12`,
    //         formik: formik,
    //         disabled: true,
    //     },
    // )

    useEffect(() => {
        if (allCountries.length && userData) {
            const {
                users_country,
                users_state,
                custom_users_seniority,
                custom_users_job_function,
                custom_users_company_category,
                custom_users_company_head_count,
            } = userData

            const viewDataUpdates = {}

            if (users_country) {
                const country = allCountries.find((country) => country.isoCode === users_country)
                viewDataUpdates.users_country = country ? country.name : ''
            }

            if (users_state) {
                const state = allStates.find((state) => state.isoCode === users_state)
                viewDataUpdates.users_state = state ? state.name : ''
            }

            const fetchData = (data, id) => {
                const item = data.find((item) => item.id == id)
                return item ? item.description : ''
            }

            viewDataUpdates.custom_users_seniority = fetchData(
                alldata_all_dropdown,
                custom_users_seniority,
            )
            viewDataUpdates.custom_users_job_function = fetchData(
                alldata_all_dropdown,
                custom_users_job_function,
            )
            viewDataUpdates.custom_users_company_category = fetchData(
                alldata_all_dropdown,
                custom_users_company_category,
            )
            viewDataUpdates.custom_users_company_head_count = fetchData(
                alldata_all_dropdown,
                custom_users_company_head_count,
            )

            setViewData((prevData) => ({
                ...prevData,
                ...viewDataUpdates,
            }))
            setReload((reload) => !reload)
        }
    }, [allCountries, userData])

    // useEffect(() => {
    //     if (allCountries.length && userData) {
    //         const AllCountriesValues = allCountries.filter(
    //             (country) => country.isoCode == userData.users_country,
    //         )
    //         const AllStateValues = allStates.filter(
    //             (state) => state.isoCode == userData.users_state,
    //         )
    //         const AllSeniorityValues = alldata_all_dropdown.filter(
    //             (SeniorityData) => SeniorityData.id == userData.custom_users_seniority,
    //         )
    //         const AllJobValues = alldata_all_dropdown.filter(
    //             (JobData) => JobData.id == userData.custom_users_job_function,
    //         )
    //         const AllCpyValues = alldata_all_dropdown.filter(
    //             (CpyData) => CpyData.id == userData.custom_users_company_category,
    //         )
    //         const AllCpyhdCutValues = alldata_all_dropdown.filter(
    //             (CpyCoutData) => CpyCoutData.id == userData.custom_users_company_head_count,
    //         )
    //         if (allCountries.length) {
    //             setViewData({
    //                 ...userData,
    //                 users_country: AllCountriesValues[0].name,
    //                 users_state: AllStateValues[0].name,
    //                 custom_users_seniority: AllSeniorityValues[0].description,
    //                 custom_users_job_function: AllJobValues[0].description,
    //                 custom_users_company_category: AllCpyValues[0].description,
    //                 custom_users_company_head_count: AllCpyhdCutValues[0].description,
    //             })
    //             setReload(!reload)
    //         }
    //     }
    // }, [allCountries, userData])

    return (
        <FullScreenPopup
            modaltitle={'VIEW USER DETAILS'}
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false)
                props.closeUpdate()
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="userDetailsContainer">
                            <div className="userDetailsColumns">
                                <label>First Name</label>
                                <p>{formik.values.users_first_name}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Last Name</label>
                                <p>{formik.values.users_last_name}</p>
                            </div>
                            {/* <div className="userDetailsColumns">
                                <label>Email Address</label>
                                <p>{formik.values.users_email}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Phone</label>
                                <p>{formik.values.users_phone}</p>
                            </div> */}
                            {/* <div className="userDetailsColumns">
                                <label>Postal Code</label>
                                <p>{formik.values.users_zip}</p>
                            </div> */}
                            <div className="userDetailsColumns">
                                <label>Country</label>
                                <p>{viewData?.users_country}</p>
                            </div>
                            {/* <div className="userDetailsColumns">
                                <label>State</label>
                                <p>{viewData?.users_state}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>City</label>
                                <p>{formik.values.users_city}</p>
                            </div> */}
                            {/* <div className="userDetailsColumns">
                                <label>Address1</label>
                                <p>{formik.values.users_address1}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Address2</label>
                                <p>{formik.values.users_address2}</p>
                            </div> */}
                            <div className="userDetailsColumns">
                                <label>Job Title</label>
                                <p>{formik.values.custom_users_job_title}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Company Name</label>
                                <p>{formik.values.users_companyname}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Seniority</label>
                                <p>{viewData?.custom_users_seniority}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Job Function</label>
                                <p>{viewData?.custom_users_job_function}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Current Company Category</label>
                                <p>{viewData?.custom_users_company_category}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Assets Class Focus</label>
                                <p>{formik.values.custom_users_asset_class_focus}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Company Start Date</label>
                                <p>{formik.values.custom_users_company_start_date}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Company Start End</label>
                                <p>{formik.values.custom_users_position_start_date}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Current Company HeadCount</label>
                                <p>{viewData?.custom_users_company_head_count}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>LinkedIn </label>
                                <a
                                    href={userData?.custom_users_linkedin_id}
                                    className="d-flex align-items-center justify-content-start"
                                >
                                    <span className="material-icons-outlined mr-1">link</span>
                                    Click Here
                                </a>
                            </div>
                            {/* <div className="userDetailsColumns">
                                <label>Backup Email </label>
                                <p>{userData?.custom_users_alt_email}</p>
                            </div>
                            <div className="userDetailsColumns">
                                <label>Backup Phone</label>
                                <p>{userData?.custom_users_alt_phone}</p>
                            </div> */}
                        </div>
                        <div className="userDetailsContainer">
                            <div className="userDetailsColumns">
                                <label className="font-weight-bold">Professional Profile</label>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: formik.values.custom_users_bio_data,
                                    }}
                                ></p>
                            </div>
                            <div className="userDetailsColumns">
                                <label className="font-weight-bold">
                                    Current Responsibilties,Interests and Expertise
                                </label>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: formik.values.custom_users_repossibility_desc,
                                    }}
                                ></p>
                            </div>
                        </div>
                        {/* <div className="row userDetailsIoI">
                            {Object.values(mapData(emailTemplate))}
                        </div> */}

                        <div className="actionButton mt-4 d-flex justify-content-center align-items-center">
                            <SecondaryButton
                                id="configManage_cancel"
                                label="Cancel"
                                onClick={() => {
                                    toggleFullScreenPopup(false)
                                    props.closeUpdate()
                                }}
                            />
                            {/* <PrimaryButton id="configManage_submit" type="submit" label="Submit" /> */}
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default UserView
